import { useCallback } from 'react'

import {
  Command,
  CommandCheckItem,
  CommandGroup,
  CommandInput,
  CommandList,
} from '@hap/components'

import { BaseCommandListProps } from './types'

export function DirectionCommandList({
  placeholder = 'Direction',
  selected = [],
  onSelect,
  multiselect,
}: BaseCommandListProps<false, boolean>) {
  const handleToggleInbound = useCallback(() => {
    const newSelection = selected.includes(false)
      ? selected.filter((s) => s !== false)
      : [...selected, false]
    onSelect(newSelection)
  }, [selected, onSelect])

  const handleToggleOutbound = useCallback(() => {
    const newSelection = selected.includes(true)
      ? selected.filter((s) => s !== true)
      : [...selected, true]
    onSelect(newSelection)
  }, [selected, onSelect])

  return (
    <Command>
      <CommandInput placeholder={placeholder} autoFocus />
      <CommandList className="py-1">
        <CommandGroup>
          <CommandCheckItem
            value="Inbound"
            className="group mx-1 flex gap-3"
            selected={selected.includes(false)}
            onSelect={handleToggleInbound}
            multiselect={multiselect}
          >
            Inbound
          </CommandCheckItem>
          <CommandCheckItem
            value="Outbound"
            className="group mx-1 flex gap-3"
            selected={selected.includes(true)}
            onSelect={handleToggleOutbound}
            multiselect={multiselect}
          >
            Outbound
          </CommandCheckItem>
        </CommandGroup>
      </CommandList>
    </Command>
  )
}
